import firebase from 'firebase/app';

import config from './config';

// Add additional services you want to use
// Most lazy loaded in app to reduce main bundle size
import 'firebase/functions';
/**
 * Expose firebase to be used by UI
 */
if (typeof window !== 'undefined') {
  window.firebase = firebase;
  firebase.initializeApp(config.firebase);
}

/**
 * Initialize firebase
 */

export default firebase;
